const Table = () => import('@/../../coreui/components/ServerTable')
const Schema = () => import('../../components/super/Translators')
const Firmwares = () => import('../../components/super/Firmwares')
const FileUpload = () => import('../../library/FileBrowser')
const HTMLEditor = () => import('../../components/documents/HTMLEditor')
const Pipelines = () => import('../../components/super/Pipelines')
const Debug = () => import('../../components/super/Debug')
const Workflows = () => import('../../components/workflowViewer/Workflows')
export default function buildMenu (allowed) {
  return [
    {
      path: '/SupNewAccount',
      name: 'SupNewAccount',
      component: Table,
      props: {
        schema: "sch_new_account",
        table: "new_account",
        server: 'login'
      }
    },
    {
      path: '/SupStates',
      name: 'SupStates',
      component: Table,
      props: {
        schema: "sch_set_usstate",
        table: "set_usstate",
        server: 'login'
      }
    },
    {
      path: '/SupUsers',
      name: 'SupUsers',
      component: Table,
      props: {
        schema: 'sch_auth_users', 
        table: 'users', 
        server: 'login'
      } 
    },
    {
      path: '/SupOrgs',
      name: 'SupOrgs',
      component: Table,
      props: {
        schema: 'sch_auth_org', 
        table: 'org', 
        server: 'login'
      } 
    },
    {
      path: '/SupProvisions',
      name: 'SupProvisions',
      component: Table,
      props: {
        schema: 'sch_auth_provisions', 
        table: 'auth_provisions', 
        server: 'login'
      } 
    },
    {
      path: '/SupIntegrations',
      name: 'SupIntegrations',
      component: Table,
      props: {
        schema: 'sch_int_inventory', 
        table: 'int_inventory', 
        server: 'login'
      } 
    },
    {
      path: '/SupLoginSummary',
      name: 'SupLoginSummary',
      component: Table,
      props: {
        schema: 'sch_auth_log_summary', 
        table: 'log_summary', 
        server: 'login'
      } 
    },
    {
      path: '/SupDictionary',
      name: 'SupDictionary',
      component: Table, 
      props: {
        schema: 'sch_dictionary', 
        table: 'dictionary', 
        server: 'login'
      }  
    },
    {
      path: '/SupSchema',
      name: 'SupSchema',
      component: Schema
    },
    {
      path: '/SupPhrasemap',
      name: 'SupPhrasemap',
      component: Table,
      props: {
        schema: 'sch_auth_phrasemap', 
        table: 'auth_phrasemap', 
        server: 'login'
      } 
    },
    {
      path: '/SupFirmwares',
      name: 'SupFirmwares',
      component: Firmwares
    },
    {
      path: '/SupCalendar',
      name: 'SupCalendar',
      component: Table,
      props: {
        schema: 'sch_fac_calendar', 
        table: 'fac_calendar'
      } 
    },
    {
      path: '/SupDocs',
      name: 'SupDocs',
      component: Table,
      props: {
        schema: "sch_auth_doc",
        table: 'auth_doc',
        server: 'login'
      }
    },
    {
      path: '/SupStatus',
      name: 'SupStatus',
      component: Table,
      props: {
        schema: "sch_bot_heart",
        table: 'bot_heart'
      }
    },
    {
      path: '/SupBots',
      name: 'SupBots',
      component: Table,
      props: {
        schema: "sch_uibot",
        table: 'auth_bot',
        server: 'login'
      }
    }, {
      path: '/SupServices',
      name: 'SupServices',
      component: Table,
      props: {
        schema: "sch_set_scanners",
        table: "set_scanners"
      }
    },
    {
      path: '/SupBotMsg',
      name: 'SupBotMsg',
      component: Table,
      props: {
        schema: "sch_bot_msg",
        table: "auth_bot_msg",
        server: "login"
      }
    },
    {
      path: '/SupHeart',
      name: 'SupHeart',
      component: Table,
      props: {
        schema: "sch_auth_heart",
        table: "auth_heart",
        server: "login"
      }
    },
    {
      path: '/SupPlans',
      name: 'SupPlans',
      component: Table,
      props: {
        schema: "sch_auth_plans",
        table: "auth_plans",
        server: "login"
      }
    },
    {
      path: '/SupFileUpload',
      name: 'SupFileUpload',
      component: FileUpload,
      props: {
        isSuper: 'yes',
        mode: 'browse'
      }
    },
    {
      path: '/HTMLEditor',
      name: 'HTMLEditor',
      component: HTMLEditor,
      props: {
        isSuper: 'yes'
      }
    },
    {
      path: '/SupPipelines',
      name: 'SupPipelines',
      component: Pipelines
    },
    {
      path: '/SupDebug',
      name: 'SupDebug',
      component: Debug
    },
    {
      path: '/SupTasks',
      name: 'SupTasks',
      component: Table,
      props: {
        schema: "sch_sup_tasks",
        table: "sup_tasks"
      }
    }, 
    {
      path: '/SupPolicy',
      name: 'SupPolicy',
      component: Table,
      props: {
        schema: "sch_docs",
        table: "docs"
      }
    },
    {
      path: '/SupModules',
      name: 'SupModules',
      component: Table,
      props: {
        schema: "sch_sup_modules",
        table: "sup_modules",
        server: "login"
      }
    },
    {
      path: '/SupDispatchLog',
      name: 'SupDispatchLog',
      component: Table,
      props: {
        schema: "sch_dispatch_log",
        table: "dispatch_log",
        server: "login"
      }
    },
    {
      path: '/SupWorkflowTable',
      name: 'SupWorkflowTable',
      component: Table,
      props: {
        schema: "sch_auth_workflows",
        table: "auth_workflows",
        server: "login"
      }
    },
		{
      path: '/SupAppWorkflows',
      name: 'SupAppWorkflows',
      component: Table,
      props: {
        schema: "sch_auth_cortex_workflows",
        table: "auth_app_workflows",
        server: "login"
      }
    },
		{
      path: '/SupAppDocuments',
      name: 'SupAppDocuments',
      component: Table,
      props: {
        schema: "sch_auth_cortex_documents",
        table: "auth_app_documents",
        server: "login"
      }
    },
		{
      path: '/SupAppDashboards',
      name: 'SupAppDashboards',
      component: Table,
      props: {
        schema: "sch_auth_cortex_dashboards",
        table: "auth_app_dashboards",
        server: "login"
      }
    },
    {
      path: '/SupTableRemove',
      name: 'SupTableRemove',
      component: Table,
      props: {
        schema: "sch_auth_table_cleanup",
        table: "auth_table_cleanup",
        server: "login"
      }
    },
    {
      path: '/SupWorkflowRouting',
      name: 'SupWorkflowRouting',
      component: Table,
      props: {
        schema: "sch_auth_workflow_routing",
        table: "auth_workflow_routing",
        server: "login"
      }
    },
    {
      path: '/SupBotActions',
      name: 'SupBotActions',
      component: Table,
      props: {
        schema: "sch_bot_actions",
        table: "auth_bot_actions",
        server: "login"
      }
    },
    {
      path: '/supWorkflows',
      name: 'SupWorkflows',
      component: Workflows,
      props: {'org': 'auth'}
    },
    {
      path: '/METRCStates',
      name: 'METRCStates',
      component: Table,
      props: {
        schema: "sch_auth_metrc_state",
        table: "auth_metrc_state",
        server: "login"
      }
    }, {
      path: '/SupServers',
      name: 'SupServers',
      component: Table,
      props: {
        schema: "sch_auth_servers",
        table: "auth_servers",
        server: "login"
      }
    }, {
      path: '/SupServerClass',
      name: 'SupServerClass',
      component: Table,
      props: {
        schema: "sch_auth_server_class",
        table: "auth_server_class",
        server: "login"
      }
    }, {
      path: '/METRCDefaults',
      name: 'METRCDefaults',
      component: Table,
      props: {
        schema: "sch_auth_metrc_default",
        table: "auth_metrc_default",
        server: "login"
      }
    }, {
      path: '/SupGoldenVars',
      name: 'SupGoldenVars',
      component: Table,
      props: {
        schema: "sch_auth_systemvar",
        table: "auth_systemvar",
        server: "login"
      }
    }, {
      path: '/SupOrchestration',
      name: 'SupOrchestration',
      component: Table,
      props: {
        schema: "sch_auth_workflow_definitions",
        table: "auth_workflow_definitions",
        server: "login"
      }
    },
    {
      path: '/SupOrchestrationNode',
      name: 'SupOrchestrationNode',
      component: Table,
      props: {
        schema: "sch_auth_workflow_node_def",
        table: "auth_workflow_node_def",
        server: "login"
      }
    },
    {
      path: '/SupEmailStructure',
      name: 'SupEmailStructure',
      component: Table,
      props: {
        schema: "sch_email_structure",
        table: "email_structure",
        server: "login"
      }
    },
    {
      path: '/SupForms',
      name: 'SupForms',
      component: Table,
      props: {
        schema: "sch_forms",
        table: "auth_forms",
        server: "login"
      }
    },{
      path: '/SupOrgMenus',
      name: "SupOrgMenus",
      component: Table,
      props: {
        schema: "sch_org_menus",
        table: "org_menus",
        server: "login",
      }
    },{
      path: '/SupEntitlements',
      name: 'SupEntitlements',
      component: Table,
      props: {
        schema: "sch_auth_entitlements",
        table: "auth_entitlements",
        server: "login"
      }
    },{
      path: '/SupFaceRecognition',
      name: 'SupFaceRecognition',
      component: Table,
      props: {
        schema: "sch_face_recognition",
        table: "face_recognition",
        server: "org"
      }
    },
  ]
}
